import { useMemo } from 'react';

import { ArrowDown02Icon, ArrowTurnBackwardIcon, ArrowUp02Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { Trans, useTranslation } from 'react-i18next';

import { FieldTypes } from '../constants/field-types-enum';

export const useKeyboardHints = fieldType => {
  const { t, i18n } = useTranslation();
  const keyboardHint = useMemo(() => {
    switch (fieldType) {
      case FieldTypes.FreeText:
      case FieldTypes.Statement:
        return (
          <span className="text-tertiary u-font-size-x-small font-light sm-hide white-space-pre-wrap">
            <Trans
              i18nKey="keyboard.hint.pressShiftEnter"
              components={[
                <HugeiconsIcon
                  className="d-inline-block align-middle"
                  size="12"
                  icon={ArrowUp02Icon}
                  strokeWidth="3"
                />,
                <HugeiconsIcon
                  className="d-inline-block align-middle"
                  size="12"
                  icon={ArrowTurnBackwardIcon}
                  strokeWidth="3"
                />,
              ]}
            />
          </span>
        );
      case FieldTypes.MultipleChoice:
      case FieldTypes.OpinionScale:
      case FieldTypes.StarRating:
      case FieldTypes.Upload:
      case FieldTypes.Signature:
      case FieldTypes.Checkbox:
        return (
          <span className="text-tertiary u-font-size-x-small font-light sm-hide">
            {t('keyboard.hint.tabAndSpaceToSelect')}
            <div className="spacebar-icon d-inline-block align-middle u-margin-x--small"></div>
          </span>
        );
      case FieldTypes.YesNo:
        return (
          <span className="text-tertiary u-font-size-x-small font-light sm-hide">
            {t('keyboard.hint.pressTabAndYOrNToSelect')}
          </span>
        );
      case FieldTypes.Select:
        return (
          <span className="text-tertiary u-font-size-x-small font-light sm-hide">
            <Trans
              i18nKey="keyboard.hint.Select"
              components={[
                <HugeiconsIcon
                  className="d-inline-block align-middle"
                  size="12"
                  icon={ArrowUp02Icon}
                  strokeWidth="3"
                />,
                <HugeiconsIcon
                  className="d-inline-block align-middle"
                  size="12"
                  icon={ArrowDown02Icon}
                  strokeWidth="3"
                />,
              ]}
            />
          </span>
        );
      default:
        return null;
    }
  }, [fieldType, i18n.language, t]);

  return keyboardHint;
};
